"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const wrapperWeb_1 = tslib_1.__importDefault(require("../utils/wrapperWeb"));
const svg_1 = tslib_1.__importDefault(require("./svg"));
const IconAdd = (0, react_1.memo)((_a) => {
    var rest = tslib_1.__rest(_a, []);
    return ((0, jsx_runtime_1.jsx)(wrapperWeb_1.default, Object.assign({}, rest, { children: (0, jsx_runtime_1.jsx)(svg_1.default, {}) })));
});
exports.default = IconAdd;
